import { titleCase, get } from "@dex/bubl-helpers";
import OrdersApi from './OrdersApi';

let settings;

export default settings = {
    key: 'content/Orders',
    zone: 'content',
    path: '/content/Orders',
    title: "Orders",
    endpoint: OrdersApi.endpoint,
    modelName: 'Orders',
    idKey: 'id',
    primaryKey: 'id',
    indexCaps: ["viewOrders"],
    viewCaps: ["viewOrders"],
    createCaps: ["createOrders"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: OrdersApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ["user"], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title', 'storeId', 'status'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Id",
                key: "id",
                type: "text",
            },
            {
                label: "User ID",
                key: "userId",
                type: "text",
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "new", label: "New" },
                    { value: "pending", label: "Pending" },
                    { value: "checking", label: "Checking" },
                    { value: "failed", label: "Failed" },
                ]
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Request ID",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase",
            },
            {
                label: "User",
                key: "user",
                format: "ModelLink",
            },
            {
                label: "Order ID",
                key: "orderId",
            },
            {
                label: "Amount",
                key: "amount",
                format: "number"
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: OrdersApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: OrdersApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ["user"] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
        ]

    },
};